import React from 'react';
import { string, func } from 'prop-types';
import { Alert, Button } from '@thd-olt-component-react/core-ui';
import { useDrawer } from '@thd-olt-component-react/drawer';
import { Footer } from '../shared/Footer';
import { DEFAULT_SELECTED_QUOTE } from '../shared/Constants';

import * as styles from '../shared/messages.module.scss';
import * as drawerStyles from '../shared/drawers.module.scss';

export const SuccessDrawer = ({
  quoteName,
  setQuoteName,
  setSelectedQuote,
  setSuccess
}) => {
  const { closeDrawer } = useDrawer();
  const exit = () => {
    setQuoteName('');
    setSelectedQuote(DEFAULT_SELECTED_QUOTE);
    setSuccess(false);
    closeDrawer();
  };

  return (
    <div className={drawerStyles.container}>
      <div className={drawerStyles.content}>
        <div className={styles.content}>
          <Alert title="Success!" type="success" inline />
          <p className={styles.messageText}>Your item has been added to your quote:{' '}
            <span className={styles.itemName}>{quoteName}</span>
          </p>
        </div>
      </div>
      <Footer>
        <Button className={styles.button} onClick={exit}>OK</Button>
      </Footer>
    </div>
  );
};

SuccessDrawer.propTypes = {
  quoteName: string,
  setQuoteName: func.isRequired,
  setSelectedQuote: func.isRequired,
  setSuccess: func.isRequired
};

SuccessDrawer.defaultProps = {
  quoteName: ''
};